import { IntlShape } from 'react-intl';

export abstract class IReactIntlProvider {
    abstract initialize(locale: string, defaultLocale?: string): void;
    abstract getIntl(): IntlShape;
}
